export const START_FREE_WEEK_LINK = "https://my.w.tt/nTgQCWKxC6"
export const PREMIUM_PLUS_LINK = "https://my.w.tt/3SDAkN1xC6"
